import axios from "axios";

declare const API_BASE_URL: string;
declare const API_BASE_URL_DEV: string;
declare const API_BASE_URL_TOKEN: string;
declare const API_BASE_URL_TOKEN_DEV: string;
declare const API_BASE_MOKA: string;

// Helper to retrieve token with fallback
const getAuthToken = (preferredKey: "dev" | "prod" = "prod"): string | null => {
  if (preferredKey === "dev") {
    return (
      localStorage.getItem("access_token_dev") ||
      sessionStorage.getItem("access_token_dev") ||
      localStorage.getItem("token_dev") ||
      sessionStorage.getItem("token_dev") ||
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token") ||
      localStorage.getItem("token") ||
      sessionStorage.getItem("token")
    );
  }
  return (
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    localStorage.getItem("access_token_dev") ||
    sessionStorage.getItem("access_token_dev") ||
    localStorage.getItem("token_dev") ||
    sessionStorage.getItem("token_dev")
  );
};

// ─── Production API ───────────────────────────────────────────────────────────
// Base: https://tenantaccessapi.lippomallpuri.com:8443/api
// Token key: "access_token"
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getAuthToken("prod");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

// ─── Development API ──────────────────────────────────────────────────────────
// Base: https://devapi.lippomallpuri.com:8443/TenantAccessAPI/api
// Token key: "access_token_dev"
export const apiDev = axios.create({
  baseURL: API_BASE_URL_DEV,
  headers: { "Content-Type": "application/json" },
});

apiDev.interceptors.request.use((config) => {
  const token = getAuthToken("dev");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});


// TOKEN YA GES YA 

// ─── Production Token API ─────────────────────────────────────────────────────
// Base: https://tenantaccessapi.lippomallpuri.com:8443
export const tokenApi = axios.create({
  baseURL: API_BASE_URL_TOKEN,
  headers: { "Content-Type": "application/json" },
});

tokenApi.interceptors.request.use((config) => {
  const token = getAuthToken("prod");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

// ─── Development Token API ────────────────────────────────────────────────────
// Base: https://devapi.lippomallpuri.com:8443/TenantAccessAPI
export const tokenApiDev = axios.create({
  baseURL: API_BASE_URL_TOKEN_DEV,
  headers: { "Content-Type": "application/json" },
});

tokenApiDev.interceptors.request.use((config) => {
  const token = getAuthToken("dev");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

// Buat Moka

// ─── Moka proxy ───────────────────────────────────────────────────────────────
// Base: API_BASE_MOKA
export const tempApi = axios.create({
  baseURL: API_BASE_MOKA,
  headers: { "Content-Type": "application/json" },
});

tempApi.interceptors.request.use((config) => {
  const token = getAuthToken("prod");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});